/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import MfaCodeEntry from '../../contentViews/MfaCodeEntry';

import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import ContentFrame from '../../applicationFrame/ContentFrame';
import { AppHeaderScrollableTextWithLanguage } from '../../components/appNav/AppHeaderScrollable';
import ContentWrapper from '../../components/ContentWrapper';

class MfaVerification extends React.Component {

  constructor(props) {
    super(props);

    this.submitMfaCode = this.submitMfaCode.bind(this);
    this.onChangeMfaCode = this.onChangeMfaCode.bind(this);
    this.onClear = this.onClear.bind(this);

    this.state = {
      mfaCode: '',
    };
  }

  onChangeMfaCode(value) {
    this.setState({
      mfaCode: value,
    });
  }

  onClear() {
    this.props.clearError();
  }

  submitMfaCode() {
    if (this.isMfaCodeGoodEnough()) {
      this.props.submitMfaCode(this.state.mfaCode);
    } else {
      this.props.submitMfaCode('');
    }
  }

  isMfaCodeGoodEnough() {
    return this.state.mfaCode.length > 5;
  }

  render() {
    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            goBack={this.props.cancelMfa}
            submit={this.submitMfaCode}
            submitDisabled={!this.isMfaCodeGoodEnough()}
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableTextWithLanguage
                id="2FACodeEntry.title.text"
              />
              <ContentWrapper>
                <MfaCodeEntry
                  token={this.props.token}
                  isWaitingForMfa={true}
                  cancelMfaRoute=""
                  errorMessage={this.props.errorMessage}
                  mfaCode={this.state.mfaCode}
                  mobileNumber=""
                  submitMfaCode={this.submitMfaCode}
                  onChangeMfaCode={this.onChangeMfaCode}
                  onFocus={this.onClear}
                  onResend={() => { this.onClear(); this.setState({ mfaCode: '' }); }}
                />
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
MfaVerification.propTypes = {
  token: PropTypes.string.isRequired,
  submitMfaCode: PropTypes.func.isRequired,
  cancelMfa: PropTypes.func.isRequired,
  errorMessage: PropTypes.any,
  clearError: PropTypes.func,
};

export default MfaVerification;
